import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { switchMap, map, catchError, mapTo, tap } from 'rxjs/operators';
import { Type } from './redux';
import util from '../../../core/utils';

/**
 * 退出登录
 */

const logout = (action$, state$, { fetch }) =>
  action$.pipe(
    ofType(Type.LOGOUT_FROM_WL),
    // switchMap(() =>
    //   fetch({
    //     url: '/web/j/toupingBean.logout.rpc',
    //   }),
    // ),
    tap(() => {
      util.ls.del(util.ls.LS_KEYS.TP_RESTORE_FLAG);
      util.ls.del(util.ls.LS_KEYS.TP_PAGE_NAME);
      util.ls.del(util.ls.LS_KEYS.TP_WS_PULL);
      util.ls.del(util.ls.LS_KEYS.TP_ROOM_ID);
      util.ls.del(util.ls.LS_KEYS.TP_REDUX_STATE_TREE);
      // document.cookie = 'NTESSTUDYSI=null;domain=.icourse163.org;path=/;expires=Sat Jan 01 2000 08:00:00 GMT+0800';
    }),
    mapTo({
      type: Type.LOGOUT_SUCCESS_FROM_WL,
    }),
    catchError(() => {
      // todo nottify 弹窗提示
      return of().pipe(
        map(() => ({
          type: Type.LOGOUT_FAILED_FROM_WL,
        })),
      );
    }),
  );

export default [logout];
